import { useQuery } from "react-query";

const fetchBanners = async () => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_REACT_APP_API_URL}/api/banners`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export const useBanners = () => {
  const { data, isLoading } = useQuery({
    queryKey: [`banners`],
    queryFn: () => fetchBanners(),
  });

  return {
    data,
    isLoading,
  };
};
